/**
 =========================================================
 * Material Dashboard 2 React - v2.0.0
 =========================================================

 * Skeleton by: www.creative-tim.com

 Heavly modified by www.stefanofrasca.com | @fefoweb

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import { Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

import Icon from '@mui/material/Icon';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Material Dashboard 2 PRO React base styles
import typography from 'assets/theme/base/typography';
import { ROUTE_CREDITS } from 'context/constants';
import { getLocalStorage, LS_AUTHCOMPANY } from '../../lib/storage';
import { getCompanyFromTenant } from '../../lib/utils';

function Footer({ links, developer }) {
  const companyData = getCompanyFromTenant(getLocalStorage(LS_AUTHCOMPANY));
  const { href: devHref, name: devName } = developer;
  const { size } = typography;

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link to={link.to} key={`${link.to}_footer`}>
          <MDTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  const Company = ({ data }) => {
    // Verifichiamo che l'oggetto data (companyData) esista e abbia le proprietà necessarie
    if (!data || !data.company) {
      return null;
    }

    const { url, company } = data;

    return (
      <MuiLink href={url || '#'} target="_blank">
        <MDTypography variant="button" fontWeight="medium">
          &nbsp;{company}&nbsp;
        </MDTypography>
      </MuiLink>
    );
  };
  Company.displayName = 'Company';
  Company.propTypes = {
    data: PropTypes.shape({
      url: PropTypes.string,
      company: PropTypes.string,
    }),
  };
  Company.defaultProps = {
    data: { url: 'https://google.com', company: 'Demo' },
  };

  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection={{ xs: 'column', lg: 'row' }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        &copy; {new Date().getFullYear()}, made with
        <MDBox fontSize={size.md} color="text" mb={-0.5} mx={0.25}>
          <Icon color="inherit" fontSize="inherit">
            favorite
          </Icon>
        </MDBox>
        by
        <MuiLink href={devHref} target="_blank">
          <MDTypography variant="button" fontWeight="medium">
            &nbsp;{devName}&nbsp;
          </MDTypography>
        </MuiLink>
        for
        <Company data={companyData} />
        and for usable management systems&nbsp;
      </MDBox>
      <MDBox
        component="ul"
        sx={({ breakpoints }) => ({
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          listStyle: 'none',
          mt: 3,
          mb: 0,
          p: 0,

          [breakpoints.up('lg')]: {
            mt: 0,
          },
        })}
      >
        {renderLinks()}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  developer: { href: 'https://www.stefanofrasca.com', name: 'Stefano Frasca', target: '_blank' },
  links: [{ to: ROUTE_CREDITS, name: 'Credits' }],
};

// Typechecking props for the Footer
Footer.propTypes = {
  developer: PropTypes.objectOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Footer;
